module.exports = __webpack_public_path__ + "img/ashleen_pic.2e1c1700.png";